import React, {useEffect, useMemo, useState} from "react";
import {isEmpty} from "lodash";
import {clsx} from "clsx";
import {isMobile} from "react-device-detect";
import IMG from "../../constants/image";
import addressStore from "../../store/addressStore";
import popupStore from "../../store/popupStore";
import {useNavigate, useSearchParams} from "react-router-dom";
import {deleteAddress, updateAddress} from "../../network/addressApi";
import {StoreFormAddress} from "../StoreFormAddress/StoreFormAddress";
import Button from "../Common/Button";
import AddressItem from "./AddressItem";
import {PATH, VARIANT} from "../../constants";
import ImageBasic from "../Common/Image/ImageBasic";
import {text} from "../../constants/text";
import appStore from "../../store/appStore";
import {fetchAddressById, fetchAddresses} from "../../services/addressServices";
import Pagination from "../Pagination/Pagination";


const ListAddress = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const searchIdAddress = searchParams.get('id');
    const searchAdd = searchParams.get('add');
    const {addressAll, detailAddress} = addressStore()
    const {setPopup} = popupStore() || {};
    const {fromNativeApp} = appStore();
    const [itemSelected, setItemSelected] = useState('');

    // Add state for pagination
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(5); // Number of addresses displayed on each page

    const dataItemAddress = useMemo(() => {
        if (itemSelected) return itemSelected;
        if (detailAddress) return detailAddress;
        return {}
    }, [detailAddress, itemSelected])

    // Use data directly from API
    const paginatedAddresses = addressAll?.items || [];
    // Calculate total number of pages based on totalItems from API
    const totalPages = useMemo(() => {
        if (isEmpty(addressAll?.items)) return 1;
        return Math.ceil(addressAll?.count / itemsPerPage);
    }, [addressAll, itemsPerPage]);

    // Process when changing pages
    const handlePageChange = (page) => {
        if (page < 1 || page > totalPages) return;
        setCurrentPage(page);
    };

    const handleAddAddress = () => {
        if (isMobile) {
            const currentParams = new URLSearchParams(window.location.search);
            currentParams.set('add', 'true');
            navigate(`?${currentParams.toString()}`, undefined);
        } else
            setPopup({
                isOpen: true,
                data: {
                    customContent: () => <StoreFormAddress
                        title='Địa chỉ của bạn'
                        isNewAddress/>,
                }
            })
    }
    const handleUpdateAddress = (item) => {
        if (isMobile) {
            const currentParams = new URLSearchParams(window.location.search);
            currentParams.set('id', item?.id);
            navigate(`?${currentParams.toString()}`, undefined);
            setItemSelected(item)
        } else
            setPopup({
                isOpen: true,
                data: {
                    customContent: () => <StoreFormAddress
                        title='Địa chỉ của bạn'
                        data={item}/>,
                }
            })
    }
    const handlePrimary = (id) => {
        const idString = id.toString();
        setPopup({
            isOpen: true,
            data: {
                title: 'Bạn muốn thay đổi địa chỉ nhận hàng?',
                image: IMG.popupUpdateStatus,
                btnCancelNew: {
                    label: 'Quay lại',
                    action: () => setPopup({})
                },
                isHideButtonClose: true,
                accept: {
                    label: 'Đồng ý',
                    action: () => {
                        updateAddress(idString, {isPrimary: true}).then((res) => {
                            if (res.success) {
                                // Gọi lại API với trang hiện tại
                                fetchAddresses({page: currentPage, limit: itemsPerPage})
                                setPopup({})
                            }
                        })
                    }
                }
            }
        })
    }

    const handleDeleteAddress = (id) => {
        setPopup({
            isOpen: true,
            data: {
                title: 'Bạn muốn xoá địa chỉ này?',
                image: IMG.popupUpdateStatus,
                btnCancelNew: {
                    label: text.skip,
                    action: () => setPopup({})
                },
                accept: {
                    label: 'Đồng ý xoá',
                    action: () => {
                        deleteAddress(id.toString()).then((res) => {
                            if (res.success) {
                                setPopup({})
                                if (isMobile) {
                                    navigate(PATH.ADDRESS);
                                }
                                if (paginatedAddresses.length === 1 && currentPage > 1) {
                                    setCurrentPage(currentPage - 1);
                                } else {
                                    fetchAddresses({page: currentPage, limit: itemsPerPage})
                                }
                            }
                        })
                    }
                }
            }
        })
    }


    useEffect(() => {
        fetchAddresses({page: currentPage, limit: itemsPerPage})
    }, [currentPage]);

    useEffect(() => {
        if (searchIdAddress) {
            fetchAddressById(searchIdAddress)
        }
    }, [searchIdAddress]);

    if ((searchIdAddress || searchAdd) && isMobile) {
        return (
            <div className='px-4 animate-fadeIn pb-24'>
                <StoreFormAddress
                    title='Địa chỉ của bạn'
                    data={dataItemAddress}
                    isNewAddress={searchAdd || ''}
                    isHideButton={!!searchAdd || (searchIdAddress && dataItemAddress?.isPrimary)}
                    handleDeleteAddress={handleDeleteAddress}/>
            </div>
        )
    }

    return (
        <div
            className={clsx('relative md:bg-white w-full animate-fadeIn md:py-6 rounded-xl px-4')}>
            <div
                onClick={handleAddAddress}
                className={clsx('md:hidden fixed right-5 cursor-pointer z-[100] flex items-center justify-center space-x-1 text-sm text-white',
                    fromNativeApp ? 'top-[68px]' : 'top-[24px]'
                )}>
                <div className='text-2xl'>+</div>
                <div>{text.add}</div>
            </div>
            <div className='relative hidden md:flex gap-[5px] justify-center items-center mb-5'>
                <img className='w-6 h-6' src={IMG.icon.locationActive} alt="address"/>
                <p className='text-sm md:text-xl font-bold'>{text.numberAddress}</p>
            </div>
            <div
                className='flex items-center justify-between w-full px-4 py-2 md:py-4 bg-[#F3F8F6] rounded-xl md:rounded-none md:rounded-t-xl'>
                <div className='flex items-center text-sm space-x-2 md:max-w-96'>
                    <ImageBasic src={IMG.icon.errorOutlineBlack} alt="error outline"/>
                    <div>{text.yourPickupAddressList}</div>
                </div>
                <Button className='hidden md:block w-full md:w-[160px] text-sm' variant={VARIANT.PRIMARY} type="submit"
                        onClick={handleAddAddress}>
                    {text.addAddressNewPlus}
                </Button>
            </div>
            <div className='text-sm text-black mt-4 md:mt-0'>
                {!isEmpty(paginatedAddresses) && paginatedAddresses.map((item, index) => (
                    <AddressItem key={item.id}
                                 item={item}
                                 addressAll={addressAll}
                                 index={index + (currentPage - 1) * itemsPerPage}
                                 handleDeleteAddress={handleDeleteAddress}
                                 handlePrimary={handlePrimary}
                                 handleUpdateAddress={handleUpdateAddress}/>

                ))}
                {totalPages > 1 && (
                    <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                    />
                )}
            </div>
            <div className='md:hidden flex items-end justify-end w-full py-4'>
                <Button className='w-full md:w-auto text-sm' variant={VARIANT.PRIMARY} type="submit"
                        onClick={handleAddAddress}>
                    {text.addAddressNewPlus}
                </Button>
            </div>
        </div>
    )
}

export default ListAddress;